import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.QBooksPurchaseOrderFields', {
    mailingAddressFieldTitle: 'Mailing Address',
    dateFieldTitle: 'Date',
    numberFieldTitle: 'Order number',
    emptyPurchaseOrderNumber: 'Allocated on approval',
});
